<template>
    <div>
        <div v-if="!detailVisible">
            <div style="margin-top: 15px" v-loading="loading">
                <el-row :gutter="12">
                    <el-col :span="8">
                        <el-button type="primary" style="margin-left: 3px;" icon="el-icon-top" @click="sns='',importVisible=true">导入</el-button>
                        <el-button type="primary" style="margin-left: 3px;" icon="el-icon-delete" @click="del()">删除</el-button>
                    </el-col>
                    <el-col :span="16">
                        <div style="text-align: right;">
                            <el-select style="width: 110px;" v-model="filterStatus" placeholder="滤芯状态">
                                <el-option value="0" label="全部"></el-option>
                                <el-option value="1" label="差"></el-option>
                                <el-option value="2" label="良"></el-option>
                                <el-option value="3" label="优"></el-option>
                            </el-select>
                            <el-select style="width: 130px;" v-model="selectValue" placeholder="请选择">
                                <el-option value="1" label="设备条形码"></el-option>
                            </el-select>
                            <el-input type="text" style="width:255px;margin-left: 3px;" v-model="queryValue" placeholder="请输入"></el-input>
                            <el-button type="primary" style="margin-left: 3px;" icon="el-icon-search" @click="updateTable">搜索</el-button>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div style="margin-top: 15px;">
                <el-table
                          ref="multipleTable"
                          :data="tableData"
                          style="width: 100%"
                          element-loading-text="数据正在加载中"
                          @selection-change="handleSelectionChange"
                          :row-style="rowClass">
                    <el-table-column type="selection" width="60"></el-table-column>
                    <el-table-column prop="nid" label="NID"></el-table-column>
                    <el-table-column prop="sn" label="序列号"></el-table-column>
                    <el-table-column label="设备类型">
                        <template slot-scope="scope">
                            <span v-if="scope.row.ntId === 1024">商用净水器</span>
                            <span v-if="scope.row.ntId === 1030">家用净水器</span>
                        </template>
                    </el-table-column>
                    <el-table-column prox="online" label="联网状态">
                        <template slot-scope="scope">
                            <el-row type="flex" style="margin-right: 10px;margin-left: 10px">
                                <div v-if="scope.row.online"
                                     style="background-color: limegreen;width: 10px;height:10px;border-radius: 50%"></div>
                                <div v-else style="background-color: #cd0000;width: 10px;height:10px;border-radius: 50%">
                                </div>
                            </el-row>
                        </template>
                    </el-table-column>
                    <el-table-column prop="status" label="工作状态">
                        <template slot-scope="scope">
                            <div v-if="scope.row.status">
                                <i class="el-icon-sunny" style="color:orange"></i>
                            </div>
                            <div v-else>
                                <i class="el-icon-moon" style="color:blue"></i>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="lockMark" label="锁定">
                        <template slot-scope="scope">
                            <div v-if="!scope.row.lockMark">
                                <icon name="unlock" :scale="2" />
                            </div>
                            <div v-else>
                                <icon name="lock" :scale="2"></icon>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="filterStatus" label="滤芯状态">
                        <template slot-scope="scope">
                            <span v-if="scope.row.filterStatus === 1">差</span>
                            <span v-if="scope.row.filterStatus === 2">良</span>
                            <span v-if="scope.row.filterStatus === 3">优</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <button @click="showDetail(scope.row.nid,scope.row.sn);detailVisible=true"
                                    v-if="scope.row.ntId==1024||scope.row.ntId==1106">详情</button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination background style="text-align:right;margin-top: 15px;margin-bottom: 65px;"
                               @current-change="handleCurrentChange" :current-page="params.pageId" :page-size="10"
                               layout="total, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
            <el-dialog title="设备导入" :visible.sync="importVisible" width="600px" :modal-append-to-body="false" :close-on-click-modal="false">
                <el-select v-model="originalAppid" style="margin-bottom: 20px;">
                    <el-option v-for="item in allowedBrands" :key="item.allowedAppid" :label="item.allowedName" :value="item.allowedAppid"></el-option>
                </el-select>
                <el-input
                          type="textarea"
                          :rows="8"
                          placeholder="请输入待导入的设备序列号，以英文逗号分割"
                          v-model="sns"
                          @input="inputHandler">
                </el-input>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="importVisible = false">取消</el-button>
                    <el-button type="primary" @click="importDevice()">确定</el-button>
                </div>
            </el-dialog>
        </div>
        <div v-show="detailVisible">
            <el-button type="primary" @click="detailVisible=false" icon="el-icon-arrow-left">返回</el-button>
            <Detail ref="child" @close="detailVisible=false"></Detail>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import {
        request
    } from '@/utils/request';
    import Detail from '@/views/crossBrandShare/waterPurifierDetail';
    export default {
        components: {
            Detail
        },
        props: {},
        data() {
            return {
                loading: false,
                importVisible: false,
                pageNum: 10,
                params: {
                    size: 10,
                    pageId: 1,
                },
                total: 0,
                tableData: [],
                multipleSelection: [],
                selectValue: '',
                queryValue: '',
                detailVisible: false,
                curNid: 0,
                filterStatus: '',
                originalAppid: '',
                sns: '',
                allowedBrands: []
            };
        },
        computed: {},
        watch: {},
        methods: {
            inputHandler() {
                this.sns = this.sns.replaceAll(/，/g, ',');
            },
            showDetail(nid, sn) {
                this.$refs.child.init(nid, sn);
            },
            importDevice() {
                if (this.originalAppid == '') {
                    this.$message.error("请选择设备原所属公司");
                }
                request({
                    url: '/admin/crossBrandShare/importDevice.do',
                    method: 'get',
                    params: {
                        originalAppid: this.originalAppid,
                        sns: this.sns
                    }
                }).then(res => {
                    if (res.data == 0) {
                        this.$message.success('操作成功');
                    } else {
                        this.$message.error("失败【" + res.data + "】个");
                    }
                    this.importVisible = false;
                    this.updateTable();
                });

            },
            del() {
                if (this.multipleSelection.length == 0) {
                    this.$message.warning("请选择操作的设备");
                    return;
                }
                let nids = "";
                this.multipleSelection.forEach(element => {
                    nids = nids + ',' + element.nid;
                });
                nids = nids.substring(1);
                this.$confirm(
                        '是否批量删除设备'
                    )
                    .then(_ => {
                        request({
                            url: '/admin/crossBrandShare/deleteDevice.do',
                            method: 'get',
                            params: {
                                nids: nids
                            }
                        }).then(res => {
                            if (res.data) {
                                this.$message.success('操作成功');
                                this.updateTable();
                            } else {
                                this.$message.error("操作失败");
                            }
                        });
                    })
                    .catch(_ => {})
            },
            listAllowedAppid() {
                request({
                    url: '/admin/crossBrandShare/listAllowedAppid.do',
                    method: 'get',
                    params: {}
                }).then(res => {
                    this.allowedBrands = res.data;
                });
            },
            updateTable() {
                var conditions = {
                    pageId: this.params.pageId,
                    size: this.params.size,
                    filterStatus: this.filterStatus
                }
                if (this.selectValue != '') {
                    if (this.selectValue == '1' && this.queryValue != '') {
                        conditions.sn = this.queryValue
                    }
                }
                this.loading = true
                axios
                    .get('/admin/crossBrandShare/list.do', {
                        params: conditions
                    })
                    .then(({
                        data
                    }) => {
                        if (data.status === '200') {
                            this.tableData = data.data
                            this.total = data.totalCount
                        } else {
                            this.$message.error(data.message)
                        }

                    })
                    .finally(() => {
                        this.loading = false
                    })
            },
            rowClass({
                row,
                rowIndex
            }) {
                if (rowIndex % 2 == 0) {
                    return 'background:#F1F2F7;'
                } else {
                    return 'background:white;'
                }
                return ''
            },
            handleCurrentChange(val) {
                this.params.pageId = val;
                this.updateTable();
            },
            handleSelectionChange(val) {
                this.multipleSelection = val
            },
        },
        created() {

        },
        mounted() {
            this.updateTable();
            this.listAllowedAppid();
        },
        beforeCreate() {},
        beforeMount() {},
        beforeUpdate() {},
        updated() {},
        beforeDestroy() {},
        destroyed() {},
        activated() {},
    }
</script>
<style scoped>

</style>